import { NavigateFunction } from 'react-router-dom';
import { Dispatch } from 'redux';
import * as onboardingActions from '../../store/onboardingV2/actions.ts';
import { DEFAULT_SKILL_NAME, DEFAULT_SKIP_ONBOARDING_DATA } from './onboardingConstants.ts';

export const navigateAfterRegistration = (
  navigate: NavigateFunction,
  dispatch: Dispatch,
  skipOnboarding: boolean,
  skills: any[]
): void => {
  if (skipOnboarding) {
    const defaultSkill = skills.find((skill: any) => skill.name === DEFAULT_SKILL_NAME);
    
    const defaultData = {
      ...DEFAULT_SKIP_ONBOARDING_DATA,
      userSkills: defaultSkill ? [{ id: defaultSkill.id, name: defaultSkill.name }] : [],
    };
    
    dispatch(onboardingActions.setAccountType(defaultData.accountType as any));
    dispatch(onboardingActions.setPersonaForm(defaultData.personaForm));
    dispatch(onboardingActions.setEmpresaForm(defaultData.empresaForm));
    dispatch(onboardingActions.setUserSkills(defaultData.userSkills));
    dispatch(onboardingActions.setWorkZones(defaultData.workZones));
    dispatch(onboardingActions.setAllCountry(defaultData.allCountry));
    dispatch(onboardingActions.setUserImage(defaultData.userImage));
    dispatch(onboardingActions.setFromSkip(true));
    dispatch(onboardingActions.setStep(4));
    
    navigate('/onboarding?step=summary');
  } else {
    dispatch(onboardingActions.setFromSkip(false));
    dispatch(onboardingActions.setWorkZones([]));
    dispatch(onboardingActions.setAllCountry(false));
    dispatch(onboardingActions.setStep(1));
    navigate('/onboarding');
  }
};

export const getStepFromQuery = (searchParams: URLSearchParams): number => {
  const stepParam = searchParams.get('step');
  
  if (stepParam === 'summary') {
    return 4;
  }
  
  return 1;
};

export const getNavigationPath = (userData: any): string => {
  if (userData?.type === null) {
    return '/onboarding';
  }
  
  if (
    (userData?.name && userData?.last_name && userData?.type !== null) ||
    (userData?.razon_social && userData?.type !== null)
  ) {
    return '/dashboard';
  }
  
  return '/';
};

export const navigateToNextStep = (
  currentStep: number,
  navigate: NavigateFunction,
  dispatch: Dispatch
): void => {
  const nextStep = Math.min(currentStep + 1, 4);
  dispatch(onboardingActions.setStep(nextStep as any));
  
  if (nextStep === 4) {
    navigate('/onboarding?step=summary');
  } else {
    navigate('/onboarding');
  }
};

export const navigateToPreviousStep = (
  currentStep: number,
  navigate: NavigateFunction,
  dispatch: Dispatch
): void => {
  const prevStep = Math.max(currentStep - 1, 1);
  dispatch(onboardingActions.setStep(prevStep as any));
  navigate('/onboarding');
};
